import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {EntityTypes} from 'web-app/react/entities/global-search/model';
import * as GlobalSearchApi from 'web-app/react/entities/global-search/api';

import * as Actions from './actions';

const searchEmployee = action$ =>
    action$
        .ofType(Actions.searchEmployee.type)
        .debounceTime(500)
        .mergeMap(({payload}) => {
            if (payload.term) {
                return GlobalSearchApi.search(payload.term, [EntityTypes.Employee], [payload.institutionId])
                    .map(({searchItems}) => Actions.searchEmployeeSuccess.action({searchItems}))
                    .catch(e => Observable.of(Actions.searchEmployeeFailed.action(e)));
            } else {
                return Observable.of(Actions.searchEmployeeAborted.action());
            }
        });

const searchSecondaryEmployee = action$ =>
    action$
        .ofType(Actions.searchSecondaryEmployee.type)
        .debounceTime(500)
        .mergeMap(({payload}) => {
            if (payload.term) {
                return GlobalSearchApi.search(payload.term, [EntityTypes.Employee], [payload.institutionId])
                    .map(({searchItems}) => Actions.searchSecondaryEmployeeSuccess.action({searchItems}))
                    .catch(e => Observable.of(Actions.searchSecondaryEmployeeFailed.action(e)));
            } else {
                return Observable.of(Actions.searchSecondaryEmployeeAborted.action());
            }
        });

export default combineEpics(searchEmployee, searchSecondaryEmployee);
